<div class="others-image--gallery">
  <ngx-gallery *ngIf="this.images.length" [options]="this.options" [images]="this.images"></ngx-gallery>
  <app-image-placeholder *ngIf="isLoading"></app-image-placeholder>
</div>
